import { getTranslation } from '@easy-expense/intl-client';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

export const StatementReconciliationHeader: React.FC = () => {
  return (
    <Layout.Column>
      <OpenSans.Primary size={32} weight="bold-700">
        {getTranslation('Statement Reconciliation')}
      </OpenSans.Primary>
      <Spacer.Vertical size={4} />
    </Layout.Column>
  );
};
